export enum ScoringMode {
  COEFFICIENT = 'COEFFICIENT',
  PONDERATION = 'PONDERATION',
}

export const scoringModeLabels: Record<ScoringMode, string> = {
  [ScoringMode.COEFFICIENT]: 'Coefficients',
  [ScoringMode.PONDERATION]: 'Pondération',
};

export interface ICycle {
  id?: string;
  nom?: string;
  ecoleId?: string;
  scoringMode?: ScoringMode | null;
}

export const defaultValue: Readonly<ICycle> = {
  id: null,
  nom: '',
  ecoleId: null,
  scoringMode: null,
};
